"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CourseEnrollment_1 = __importDefault(require("./CourseEnrollment"));
/**
 * Represents a page of Course Enrollments
 * @param {Array<CourseEnrollment>} page.items array of course enrollments
 * @param {number} page.count number of items returned
 * @param {Object} page.lastKey key of the last returned item
 */
class CourseEnrollmentsPage {
    constructor(fields) {
        if (!fields) {
            return;
        }
        if (fields.items !== undefined) {
            //@ts-ignore
            this.items = fields.items.map(item => new CourseEnrollment_1.default(item));
        }
        if (fields.count !== undefined) {
            this.count = fields.count;
        }
        if (fields.lastKey !== undefined) {
            this.lastKey = fields.lastKey;
        }
    }
}
exports.default = CourseEnrollmentsPage;
//# sourceMappingURL=CourseEnrollmentsPage.js.map